
import { useApiStore } from "@/stores/apiStore";
import { defineComponent } from "vue";
import { AxiosError } from "axios";
import { useAuthStore } from "@/stores/authStore";
export default defineComponent({
	setup() {
		const api = useApiStore();
		const authStore = useAuthStore();
		const user = authStore.user;

		return {
			user,
			api
		};
	},
	name: "imdex-forgot-password",
	data: () => {
		return {
			// eslint-disable-next-line
			loginWithRedirect: {} as any,
			isAuthenticated: false,
			password: "",
			retypePassword: "",
			isLoading: false,
			errorMessage: "",
			success: false,
			passwordError: false,
			showPassword: false
		};
	},
	mounted() {
		if (
			this.user &&
			Object.keys(this.user).length &&
			this.user.id != this.$route.query.userId
		) {
			this.$router.push(`/reset-password?userId=${this.user.id}`);
		} else if (this.user && !Object.keys(this.user).length && !this.newUser) {
			this.$router.push("/");
		}
	},
	watch: {
		isAuthenticated(v) {
			if (v) {
				this.$router.push("/users");
			}
		}
	},
	computed: {
		newUser() {
			return this.$route.query.token != null;
		},
		hasUppercase() {
			const isAnyUpper = (string: string) => /\p{Lu}/u.test(string);
			return isAnyUpper(this.password);
		},
		hasLowercase() {
			const isAnyLower = (string: string) => /[a-z]/u.test(string);
			return isAnyLower(this.password);
		},
		hasNumber() {
			const hasNumber = (string: string) => /\d/.test(string);
			return hasNumber(this.password);
		},
		longerThan8() {
			return this.password.length >= 8;
		},
		hasSpecialCharacter() {
			// eslint-disable-next-line
			let format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
			return format.test(this.password);
		},
		passwordMatch() {
			return this.password == this.retypePassword && this.password != "";
		}
	},
	methods: {
		async submitForgotPassword() {
			this.isLoading = true;
			this.errorMessage = "";
			try {
				if (this.$route.query.userId != null) {
					const post: { password: string; userId: string; token?: string } = {
						userId: this.$route.query.userId.toString(),
						password: this.password
					};
					if (this.newUser) {
						post.token = this.$route.query.token?.toString();
					}
					await this.api.post({ endpoint: "/reset-password", post });
					setTimeout(() => {
						this.isLoading = false;
						this.success = true;
						this.$router.go(-1);
					}, 2000);
				}
			} catch (e) {
				if (e instanceof AxiosError) {
					this.errorMessage = e.response?.data.message;
					this.isLoading = false;
				} else {
					this.errorMessage = this.$t("resetPassword.errorUpdating");
					this.isLoading = false;
				}
			}
		},
		forgot(type: string) {
			console.log(type);
		}
	}
});
